<script setup>
import { computed } from "vue";
import PageTitle from "@/components/common/PageTitle.vue";
import MyProfile from "@/components/myProfile/Index.vue";

import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const breadcrumbs = computed(() => [
    { label: t('components.myProfile.accountDetails.pageTitle') }
])
</script>
<template>
    <PageTitle :breadcrumbs="breadcrumbs" />
    <MyProfile />
</template>

